import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'levels', en);
i18next.addResources('fr', 'levels', fr);

declare global {
  interface RegisteredLocales {
    levels: typeof en;
  }
}
